import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
const benefits = [{
  title: <>
        Terminás tu primera mesa en{' '}
        <span className="underline-green" data-id="element-12">7 días</span>.
      </>,
  desc: <>
        Cada paso numerado. Cada tiempo especificado.{' '}
        <span className="highlight-green" data-id="element-13">Sin improvisar nada</span>.
      </>
}, {
  title: <>Nunca más una burbuja arruina tu trabajo.</>,
  desc: <>
        El capítulo 6 te enseña el{' '}
        <strong className="text-[#16A34A]" data-id="element-14">sellado de poros</strong> que el 90%
        de los tutoriales se saltea.{' '}
        <em className="text-gray-500 block mt-2" data-id="element-15">
          Ese solo paso lo cambia todo.
        </em>
      </>
}, {
  title: <>
        Lográs el{' '}
        <span className="underline-green" data-id="element-16">brillo espejo profesional</span>.
      </>,
  desc: <>
        La secuencia exacta de{' '}
        <strong className="text-[#16A34A]" data-id="element-17">9 grados</strong> de lija más{' '}
        <strong className="text-[#16A34A]" data-id="element-18">3 etapas</strong> de pulido.
        <em className="text-gray-500 block mt-2" data-id="element-19">
          Sin adivinar, sin experimentar.
        </em>
      </>
}, {
  title: <>
        Dominás{' '}
        <span className="underline-green" data-id="element-20">5 efectos visuales premium</span>.
      </>,
  desc: <>
        Océano, galaxia, mármol, lava y geoda.{' '}
        <span className="highlight-green" data-id="element-21">
          Proporciones exactas de pigmento
        </span>{' '}
        y procedimiento paso a paso para cada uno.
      </>
}, {
  title: <>
        Sabés exactamente <span className="underline-green" data-id="element-22">cuánto cobrar</span>
        .
      </>,
  desc: <>
        La <strong className="text-[#16A34A]" data-id="element-23">fórmula de costeo real</strong>.{' '}
        <em className="text-gray-500 block mt-2" data-id="element-24">
          Sin regalar el trabajo ni cobrar a ojo.
        </em>
      </>
}, {
  title: <>Resolvés cualquier error sin perder la mesa.</>,
  desc: <>
        Los 8 problemas más comunes con su{' '}
        <span className="highlight-green" data-id="element-25">solución completa</span> en el
        capítulo 14.
      </>
}, {
  title: <>Construís tus propios moldes profesionales sin gastar una fortuna.</>,
  desc: <>
        <span className="highlight-green" data-id="element-26">
          Moldes reutilizables y sin fugas
        </span>
        , fabricados con materiales simples.
      </>
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BenefitsSection() {
  return <section className="py-[40px] md:py-[64px] px-5 relative bg-[#FFFFFF]" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-[20px]" data-id="element-29">
          <p className="text-subtitle text-gray-600 italic leading-relaxed mb-[18px]" data-id="element-30">
            Con Mesas Epoxi Pro, cada uno de estos problemas tiene solución:
          </p>
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-[10px] flex items-center justify-center gap-4" data-id="element-31">
            <SparklesIcon className="w-8 h-8 text-[#C9A84C]" data-id="element-32" />
            ESTO ES LO QUE LOGRÁS
          </h2>
          <div className="w-24 h-1 bg-[#C9A84C]/30 mx-auto mt-[10px]" data-id="element-33"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="flex flex-col gap-[12px]" data-id="element-34">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="card-light border-l-[5px] border-l-[#15803D] px-[20px] py-[20px] hover:border-l-[#22C55E] hover:translate-x-[4px] transition-all duration-300" data-id="element-35">
              <div className="space-y-2" data-id="element-36">
                <h3 className="text-xl md:text-2xl font-bold text-[#15803D] font-heading leading-tight" data-id="element-37">
                  {benefit.title}
                </h3>
                <p className="text-body-main text-gray-700 leading-relaxed" data-id="element-38">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}